import { gql } from '@apollo/client';
const UPDATE_MODEL_COLOR = gql `
  mutation UpdateModelColor($modelSpecificationColorId: ID!, $colorName: String!) {
    updateModelSpecificationColor(
      modelSpecificationColorId: $modelSpecificationColorId
      colorName: $colorName
    ) {
      modelSpecificationColor {
        id
        name
        isActive
      }
    }
  }
`;
export default UPDATE_MODEL_COLOR;
